<template>
	<v-col class="sponsorisasi">
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Ubah Password</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<router-link to="/">
				<div class="d-flex">
					<v-icon small color="grey">mdi-home</v-icon>
					<div class="pl-2 grey--text">Dashboard</div>
				</div>
			</router-link>
			<div class="px-2">/</div>
			<div>Ubah Password</div>
		</div>
		<div class="mt-5">
			<v-row>
				<v-col cols="12" sm="4" md="3" xl="2">
					<v-card class="pa-5 elevation-0 rounded-lg">
						<div class="bg-card-profile">
							<v-img src="/assets/background/bg-profile-picture.svg"></v-img>
						</div>
						<v-row class="mt-3">
							<v-col cols="12">
								<v-row justify="center">
									<v-col cols="7" sm="9" class="px-0 py-5">
										<div class="text-center">
											<v-img height="165" width="165" class="user-img mx-auto rounded-pill" :src="(myProfile.member_image_url) ? myProfile.member_image_url : '/assets/image/profile-pict.png'"></v-img>
											<!-- <v-img height="165" width="165" class="mx-auto rounded-pill" src="/assets/image/profile-pict.png" v-if="!myProfile.member_image_path"></v-img> -->
										</div>
									</v-col>
								</v-row>
								<div class="pt-5 text-center">
									<div class="pt-3 pt-sm-0 font-size-14 cl-secondary font-weight-500">{{ myProfile.member_name }}</div>
									<div class="font-size-11 cl-secondary">{{ myProfile.network_code }}</div>
								</div>
								<v-card
									outlined
									class="mt-4 py-1"
									v-if="myProfile.network_type"
								>
									<div class="d-flex align-center justify-center">
										<div class="my-2">
											<v-img width="48" style="height: auto;max-width: 100%;" class="mr-3" :src="getNetworkTypeBadge(myProfile.network_type)"></v-img>
										</div>
										<div class="font-size-10 font-size-xs-10 font-weight-600 d-flex flex-column">
											<div class="cl-secondary">Kemitraan Anda</div>
											<div class="text-uppercase" :style="{color: getNetworkTypeColor(myProfile.network_type)}">{{ (myProfile.network_type === 'gold') ? 'Gold Star' : (myProfile.network_type === 'repeat_order') ? 'Silver' : myProfile.network_type }}</div>
										</div>
									</div>
								</v-card>
								<template v-if="myProfile.network_type !== 'diamond'">
									<v-row class="mt-2">
										<v-col cols="12" sm="12" class="pt-1">
												<v-btn
													color="primary"
													outlined
													block
													@click="gotoUpgrade"
												><v-icon dense class="mr-1">mdi-shield-account-outline</v-icon>Upgrade</v-btn>
										</v-col>
									</v-row>
								</template>
								<div class="pt-5 border-bottom border-2px border-grey"></div>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
				<v-col cols="12" sm="5" md="4" xl="3">
					<v-row>
						<v-col cols="12">
							<v-card class="pa-3 elevation-0 rounded-lg">
								<v-row>
									<v-col cols="12">
										<v-form ref="formChangePassword" role="form">
											<v-row>
												<v-col cols="12" class="px-5 pb-0">
													<v-text-field label="Password Lama" color="primary" class="input-regis" prepend-inner-icon="mdi-key-variant" v-model="oldpassword" tabindex="1" :type="typeInput0" :append-icon="icon0" @click:append="showPassword0" :rules="rules.password"></v-text-field>
												</v-col>
												<v-col cols="12" class="px-5 pb-0">
													<v-text-field label="Password Baru" color="primary" class="input-regis" prepend-inner-icon="mdi-key-variant" v-model="password" tabindex="2" :type="typeInput1" :append-icon="icon1" @click:append="showPassword1" :rules="rules.password"></v-text-field>
												</v-col>
												<v-col cols="12" class="px-5">
													<v-text-field label="Ulangi Password Baru" color="primary" class="input-regis" prepend-inner-icon="mdi-key-variant" v-model="repassword" tabindex="3" :type="typeInput2" :append-icon="icon2" @click:append="showPassword2" :rules="rules.password" :error-messages="alertRepassword" @focus="() => alertRepassword=''"></v-text-field>
												</v-col>
											</v-row>
										</v-form>
									</v-col>
								</v-row>
							</v-card>
							<v-row class="pt-5 justify-center justify-sm-start">
								<v-col cols="6" sm="2">
									<v-btn large depressed block class="bg-primary white--text rounded-lg" @click="save" tabindex="4" :loading="btnLoadingProses" :disabled="btnLoadingProses">
										<v-icon small>mdi-key-variant</v-icon>
										<span class="pl-2">Ubah</span>
									</v-btn>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</div>
	</v-col>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
	components: {
	},
	data() {
		return {
			isActiveMember: false,
			oldpassword: '',
			password: '',
			repassword: '',
			alertRepassword: '',
			btnLoadingProses: false,
			typeInput0: 'password',
			icon0: 'mdi-eye',
			typeInput1: 'password',
			icon1: 'mdi-eye',
			typeInput2: 'password',
			icon2: 'mdi-eye',
			rules: {
				password: [
				v => !!v || 'Tidak boleh kosong',
				v => ( v && v.length >= 6 ) || "Password tidak boleh kurang dari 6",
				],
			},
			kemitraan: [
				{
					type: 'pramitra',
					color: '#03bb5a',
					belanja: '0',
					badges: '',
					classText: 'mitra-pra'
				},
				{
					type: 'silver',
					color: '#688389',
					belanja: '1.300.000',
					badges: '/assets/icon/silver.svg',
					classText: 'mitra-silver'
				},
				{
					type: 'gold',
					color: '#6e490f',
					belanja: '3.900.000',
					badges: '/assets/icon/gold.svg',
					classText: 'mitra-gold'
				},
				{
					type: 'diamond',
					color: '#2a4fd6',
					belanja: '13.000.000',
					badges: '/assets/icon/diamond.svg',
					classText: 'mitra-diamond'
				}
			],
		}
	},
	computed: {
		...mapState('auth', ['userData']),
		...mapState('profile', ['myProfile']),
	},
	methods: {
		...mapActions('profile', ['changePasswordMitra', 'changePasswordPramitra']),
		...mapActions('profile', ['getProfileMitra', 'getProfilePramitra']),

		gotoUpgrade() {
			this.$router.push({name: 'upgrade-kemitraan'})
		},

		showPassword0() {
			this.typeInput0 = this.typeInput0 == 'text' ? 'password' : 'text'
			this.icon0 = this.icon0 == 'mdi-eye' ? 'mdi-eye-off' : 'mdi-eye'
		},
		showPassword1() {
			this.typeInput1 = this.typeInput1 == 'text' ? 'password' : 'text'
			this.icon1 = this.icon1 == 'mdi-eye' ? 'mdi-eye-off' : 'mdi-eye'
		},
		showPassword2() {
			this.typeInput2 = this.typeInput2 == 'text' ? 'password' : 'text'
			this.icon2 = this.icon2 == 'mdi-eye' ? 'mdi-eye-off' : 'mdi-eye'
		},
		getNetworkTypeBadge(type) {
			if(type === 'repeat_order') type = 'silver'
			const netType = this.kemitraan.find(x => x.type === type)
			return netType.badges
		},
		getNetworkTypeColor(type) {
			if(type === 'repeat_order') type = 'silver'
			const netType = this.kemitraan.find(x => x.type === type)
			return netType.color
		},
		getData() {
			if (this.isActiveMember) {
				this.getProfileMitra()
			} else {
				this.getProfilePramitra()
			}
		},
		async checkMemberActivation(data) {
			if (data.bin_network_id === "0" || data.bin_network_id === 0) this.isActiveMember = false
			else this.isActiveMember = true
		},
		async save() {
			if (this.password !== this.repassword) {
				this.alertRepassword = "Password tidak sama"
				this.btnLoadingProses = false
			} else {
				this.alertRepassword = ''
				if (this.$refs.formChangePassword.validate()) {
					this.btnLoadingProses = await true
					let params = await {
						old_password: this.oldpassword,
						password: this.password,
						password_conf: this.repassword
					}

					if (this.isActiveMember) {
						await this.changePasswordMitra(params).then(() => {
							this.$refs.formChangePassword.reset()
							this.btnLoadingProses = false
						})
						.catch(() => {
							this.btnLoadingProses = false
						})
					} else {
						await this.changePasswordPramitra(params).then(() => {
							this.$refs.formChangePassword.reset()
							this.btnLoadingProses = false
						})
						.catch(() => {
							this.btnLoadingProses = false
						})
					}
				} else {
					this.btnLoadingProses = false
				}
			}
			this.btnLoadingProses = false
		},
	},
	async created() {
		this.$store.dispatch('setPageTitle', `Ubah Password`)
		const authData = await localStorage.getItem('mlmcore-vo-auth-data');
		const data = await JSON.parse(authData)

		await this.checkMemberActivation(data)
		this.getData()
	},
};
</script>